(function ($) {
    'use strict';

    $('.deleteButton').on('click', function (evt) {
        var $deleteButton = $(evt.target);
        var $error = $('#confirm-delete-dialog .error');
        var title = $deleteButton.prev().find('a').text();
        var id = $deleteButton.closest('.myResource').attr('id');

        $error.hide();
        $('#confirm-delete-dialog .text strong').text(title);
        $('#confirm-delete-dialog .delete-button').on('click', function (evt) {
            $error.hide();
            $.ajax({
                type: 'DELETE',
                url: '/api/teaching-resources/v2/resources/'+ encodeURIComponent(id)
            })
            .done(location.reload.bind(location, true))
            .fail($error.fadeIn.bind($error));
        });
    });

    $('.deleteButton').leanModal({top: 200, closeButton: '.cancel-button'});

})(jQuery);
